import { useParams } from "react-router-dom";
import { Seo, SITE_URL } from "@/components/Seo";
import { BlogIsland, useBlogData } from "@/components/blog/BlogIsland";
import { BLOG_DATA, BLOG_DESCRIPTION, BLOG_TITLE, blogJsonLd, blogMarkdownPath, blogPath, postTitle, renderPostIsland, type PostData } from "@/lib/blog";

/**
 * One post. The article is written in Terradium and rendered into this page
 * by the Worker (worker/blog.ts), head and all, so crawlers read the whole
 * post without running JavaScript and a new post needs no deploy.
 */
export default function BlogPost() {
  const { slug = "" } = useParams();
  const isFor = (d: unknown): d is PostData => {
    const data = d as PostData | null;
    return data?.kind === "post" ? data.post.slug === slug : (data?.kind === "missing" || data?.kind === "error") && data.slug === slug;
  };
  const data = useBlogData<PostData>(`${BLOG_DATA}/posts/${encodeURIComponent(slug)}`, isFor, { kind: "error", slug });
  const post = data?.kind === "post" ? data.post : undefined;
  return (
    <main className="mx-auto max-w-3xl px-5 pt-28 pb-20">
      {post ? (
        <Seo
          title={postTitle(post)}
          description={post.description}
          path={blogPath(post.slug)}
          image={post.image}
          type="article"
          alternates={[{ type: "text/markdown", path: blogMarkdownPath(post.slug) }]}
          jsonLd={blogJsonLd(post, SITE_URL)}
        />
      ) : (
        // The shell every post is rendered into, and a post that isn't there.
        <Seo title={data?.kind === "missing" ? "Artikel tidak ditemukan — Kanata Indonesia" : BLOG_TITLE} description={BLOG_DESCRIPTION} noindex />
      )}
      <BlogIsland html={data && renderPostIsland(data)} />
    </main>
  );
}
